export const environment = {
  production: false,
  name: 'staging',
  posthog: {
    apiKey: 'phc_IKKClqiIux0PV6LodHozvG4R7PRopjJlJiOXB74jG2B',
    host: 'https://eu.i.posthog.com'
  }
};
